import {
  generalGetLiveLogs,
  getStreamAdFilledInVideoUnitQuery,
  getStreamAdFilledQuery,
  getStreamPodFilledQuery,
  getStreamPodRequestQuery,
} from '~/src/dash/api/live_logs/controller';
import {
  IStreamAdFilledData,
  IStreamAdFilledInVideoUnitData,
  IStreamPodFilledData,
  IStreamPodRequestData,
} from '~/src/dash/api/live_logs/models';

export interface INetworkChannelLiveLogsWrapper {
  podRequest: IStreamPodRequestData[];
  podFilled: IStreamPodFilledData[];
  adFilled: IStreamAdFilledData[];
  inVideoUnit: IStreamAdFilledInVideoUnitData[];
}

export async function GetNetworkChannelLiveLogsData(
  networkChannelID: number,
  publisherID: string,
  username: string,
): Promise<INetworkChannelLiveLogsWrapper> {
  const out = {} as INetworkChannelLiveLogsWrapper;

  // Pod Request
  const streamPodRequestQuery = getStreamPodRequestQuery(networkChannelID);
  const podRequestPromise = generalGetLiveLogs<IStreamPodRequestData[]>(
    streamPodRequestQuery,
    publisherID,
    username,
  ).then(([data, err]) => {
    if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
      out.podRequest = data;
    }
    if (err !== undefined) {
      console.error(err);
    }
  });

  // Pod Filled
  const streamPodFilledQuery = getStreamPodFilledQuery(networkChannelID);
  const podFilledPromise = generalGetLiveLogs<IStreamPodFilledData[]>(
    streamPodFilledQuery,
    publisherID,
    username,
  ).then(([data, err]) => {
    if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
      out.podFilled = data;
    }
    if (err !== undefined) {
      console.error(err);
    }
  });

  // Ad Filled
  const streamAdFilledQuery = getStreamAdFilledQuery(networkChannelID);
  const adFilledPromise = generalGetLiveLogs<IStreamAdFilledData[]>(
    streamAdFilledQuery,
    publisherID,
    username,
  ).then(([data, err]) => {
    if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
      out.adFilled = data;
    }
    if (err !== undefined) {
      console.error(err);
    }
  });

  await Promise.all([podRequestPromise, podFilledPromise, adFilledPromise]);
  return out;
}

export interface IInVideoUnitLiveLogsWrapper {
  inVideoUnit: IStreamAdFilledInVideoUnitData[];
}

export async function GetInVideoUnitLiveLogsData(
  inVideoUnitID: number,
  publisherID: string,
  username: string,
): Promise<IInVideoUnitLiveLogsWrapper> {
  const out = {} as IInVideoUnitLiveLogsWrapper;

  const inVideoUnitQuery = getStreamAdFilledInVideoUnitQuery(inVideoUnitID);
  const inVideoUnitPromise = generalGetLiveLogs<IStreamAdFilledInVideoUnitData[]>(
    inVideoUnitQuery,
    publisherID,
    username,
  ).then(([data, err]) => {
    if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
      out.inVideoUnit = data;
    }
    if (err !== undefined) {
      console.error(err);
    }
  });

  await Promise.all([inVideoUnitPromise]);
  return out;
}
